import axios from "axios"
import { ACTUALITE_URL } from "../../../../services/api/URL_API"
import { toast } from "react-toastify";
import Cookies from 'js-cookie';

const BASE_URL = 'https://dkbsign.com/dkbsign_web_api/public'

const token = Cookies.get('token_admin')

export const AddActualite = async ({ title, content, img, subtitle, posteddate, alt }) => {
    const formData = new FormData();

    formData.append('title', title);
    formData.append('content', content);
    formData.append('subtitle', subtitle);
    formData.append('posteddate', posteddate);
    formData.append('alt', alt);

    formData.append('img', img);

    try {
        const response = await axios.post(`${BASE_URL}${ACTUALITE_URL}/store`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${token}`
            }
        });
        // handle success

        toast.success("L'actualité a été ajouté", {
            position: "top-center",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });

        window.location.reload()
    } catch (error) {
        toast.error("Erreur impossible d'ajouter l'actualité", {
            position: "top-center",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    }
}

export const EditActualite = async ({ title, content, img, subtitle, posteddate, alt, id }) => {
    const formData = new FormData();

    formData.append('title', title);
    formData.append('content', content);
    formData.append('subtitle', subtitle);
    formData.append('posteddate', posteddate);
    formData.append('alt', alt);

    formData.append('img', img);

    try {
        const response = await axios.post(`${BASE_URL}${ACTUALITE_URL}/update/${id}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${token}`
            }
        });
        // handle success

        toast.success("L'actualité a été modifié", {
            position: "top-center",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
        window.location.reload()
    } catch (error) {
        toast.error("Erreur impossible de modifié l'actualité", {
            position: "top-center",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    }
}

export const DeleteActualite = async ({ id }) => {

    try {
        const response = await axios.get(`${BASE_URL}${ACTUALITE_URL}/destroy/${id}`, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${token}`
            }
        });
        // handle success

        toast.success("L'actualité a été supprimé", {
            position: "top-center",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
        window.location.reload()
    } catch (error) {
        toast.error("Erreur impossible de supprimer l'actualité", {
            position: "top-center",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    }
}